module.exports = function () {
	window.$ = (el, arr = false) => {
		const res = document.querySelectorAll(el);
		return res.length > 1 ? Array.prototype.slice.call(res) : (arr ? [res[0]] : res[0]);
	}
	window._ = (...msg) => console.log(...msg);
};
